import defaultPhoto from '../../assets/default-avatar.png';

const EMAIL_HOME = 'home';
const EMAIL_WORK = 'work';
const EMAIL_OTHER = 'other';
const EMAIL_CUSTOM = 'custom';

const EMAIL_TYPES = [
  EMAIL_HOME,
  EMAIL_WORK,
  EMAIL_OTHER,
  // EMAIL_CUSTOM,
];

const PHONE_MOBILE = 'mobile';
const PHONE_WORK = 'work';
const PHONE_HOME = 'home';
const PHONE_MAIN = 'main';
const PHONE_WORKFAX = 'work_fax';
const PHONE_HOMEFAX = 'home_fax';
const PHONE_PAGER = 'pager';
const PHONE_OTHER = 'other';
const PHONE_CUSTOM = 'custom';

const PHONE_TYPES = [
  PHONE_MOBILE,
  PHONE_WORK,
  PHONE_HOME,
  PHONE_MAIN,
  PHONE_WORKFAX,
  PHONE_HOMEFAX,
  PHONE_PAGER,
  PHONE_OTHER,
  // PHONE_CUSTOM,
];

const DEFAULT_TYPE = {
  emails: EMAIL_HOME,
  phones: PHONE_MOBILE,
};

const CONTACT_TEMPLATE = {
  name: '',
  address: '',
  birthday: '',
  notes: '',
  emails: [{ value: '', type: DEFAULT_TYPE.emails }],
  phones: [{ value: '', type: DEFAULT_TYPE.phones }],
  star: false,
};

const Email = class {
  constructor(data) {
    this.data = data || {};
  }

  get address() {
    return 'address' in this.data ? this.data.address : '';
  }

  set address(data) {
    this.data.address = data;
  }

  get primary() {
    return 'primary' in this.data && this.data.primary;
  }

  get type() {
    return 'rel' in this.data ? this.data.rel.split('#').pop() : '';
  }

  set type(data) {
    this.data.rel = `http://schemas.google.com/g/2005#${data}`;
  }

  get label() {
    return 'label' in this.data ? this.data.label : '';
  }

  set label(data) {
    this.data.label = data;
  }

  get json() {
    return {
      value: this.address,
      type: this.label ? EMAIL_CUSTOM : this.type,
      label: this.label,
    };
  }
};

const Phone = class {
  constructor(data) {
    this.data = data || {};
  }

  get number() {
    return this.data.$t;
  }

  set number(data) {
    this.data.$t = data;
  }

  get primary() {
    return 'primary' in this.data && this.data.primary;
  }

  get type() {
    return 'rel' in this.data ? this.data.rel.split('#').pop() : '';
  }

  set type(data) {
    this.data.rel = `http://schemas.google.com/g/2005#${data}`;
  }

  get label() {
    return 'label' in this.data ? this.data.label : '';
  }

  set label(data) {
    this.data.label = data;
  }

  get json() {
    return {
      value: this.number,
      type: this.label ? PHONE_CUSTOM : this.type,
      label: this.label,
    };
  }
};

const Contact = class {
  photo = defaultPhoto;

  constructor(data, contactGroups) {
    this.ice = null;
    this.data = data;
    this.groups = contactGroups;
    if (data) {
      this.gemails = 'gd$email' in this.data ? this.data.gd$email.map(item => new Email(item)) : [];
      this.gphones = 'gd$phoneNumber' in this.data ? this.data.gd$phoneNumber.map(item => new Phone(item)) : [];
    }
    if (data.photo) this.photo = data.photo;
  }

  get view() {
    const name = this.name ? this.name.toLowerCase() : '';
    const email = this.email ? this.email.toLowerCase() : '';
    const phone = this.phone ? this.phone.toLowerCase() : '';
    return `${name} ${email} ${phone}`;
  }

  get id() {
    return 'id' in this.data ? this.data.id.$t.split('/').pop() : '';
  }

  set id(data) {
    this.data.id = this.data.id || {};
    this.data.id.$t = data;
  }

  get star() {
    const starId = this.groups.starredGroupID;
    if ('gContact$groupMembershipInfo' in this.data) {
      const isStarred = this.data.gContact$groupMembershipInfo.filter(item => item.href === starId);
      return isStarred.length;
    }
    return false;
  }

  set star(data) {
    if (data) {
      this.data.gContact$groupMembershipInfo = this.data.gContact$groupMembershipInfo || [];
      this.data.gContact$groupMembershipInfo.push({ href: this.groups.starredGroupID });
    } else {
      delete this.data.gContact$groupMembershipInfo;
    }
  }

  get email() {
    if (this.emails.length) {
      const primary = this.emails.filter(item => item.primary);
      return primary.length ? primary[0].address : this.emails[0].address;
    }
    return '';
  }

  get emails() {
    return this.gemails;
  }

  set emails(data) {
    this.gemails = [];
    data.forEach((item) => {
      const email = new Email();
      email.address = item.value;
      email.type = item.type;
      email.label = item.label;
      this.gemails.push(email);
    });
  }

  get phone() {
    if (this.phones.length) {
      const primary = this.phones.filter(item => item.primary);
      return primary.length ? primary[0].number : this.phones[0].number;
    }
    return '';
  }

  get phones() {
    return this.gphones;
  }

  set phones(data) {
    this.gphones = [];
    data.forEach((item) => {
      const phone = new Phone();
      phone.number = item.value;
      phone.type = item.type;
      phone.label = item.label;
      this.gphones.push(phone);
    });
  }

  get name() {
    return this.data.gd$name && this.data.gd$name.gd$fullName ? this.data.gd$name.gd$fullName.$t : '';
  }

  set name(data) {
    this.data.gd$name = this.data.gd$name || {};
    this.data.gd$name.gd$fullName = this.data.gd$name.gd$fullName || {};
    this.data.gd$name.gd$fullName.$t = data || '';
  }

  get address() {
    return 'gd$structuredPostalAddress' in this.data ? this.data.gd$structuredPostalAddress[0].gd$formattedAddress.$t : '';
  }

  set address(data) {
    this.data.gd$structuredPostalAddress = [];
    this.data.gd$structuredPostalAddress.push({ gd$formattedAddress: { $t: data } });
  }

  get birthday() {
    return 'gContact$birthday' in this.data ? this.data.gContact$birthday.when : '';
  }

  set birthday(data) {
    this.data.gContact$birthday = this.data.gContact$birthday || {};
    this.data.gContact$birthday.when = data;
  }

  get notes() {
    return 'content' in this.data ? this.data.content.$t : '';
  }

  set notes(data) {
    this.data.content = this.data.content || {};
    this.data.content.$t = data;
  }

  get json() {
    return {
      id: this.id,
      name: this.name,
      emails: this.emails.map(item => item.json),
      phones: this.phones.map(item => item.json),
      address: this.address,
      birthday: this.birthday,
      notes: this.notes,
      star: this.star ? this.groups.starredGroupID : '',
      photoLink: this.links('photo'),
    };
  }

  get iceKey() {
    return this.ice;
  }

  setIcekey(key) {
    this.ice = key;
  }

  starToggle() {
    this.star = !this.star;
  }

  links(type) {
    const link = this.data.link.filter(item => item.rel.includes(type));
    return link.length ? link[0].href : null;
  }

  setPhoto(data) {
    this.photo = data;
  }

  update(data) {
    Object.keys(data).forEach((key) => {
      this[key] = data[key];
    });
  }
};

const Contacts = class {
  constructor(data = null, contactGroups = null) {
    this.data = data;
    if (data && 'entry' in this.data.feed) {
      this.items = this.data.feed.entry.map(item => new Contact(item, contactGroups));
    } else {
      this.items = [];
    }
  }

  get etag() {
    return this.data ? this.data.feed.gd$etag : '';
  }

  getContacts(star = false, filter = '') {
    if (!this.data) return [];
    let data = this.items;
    data = star ? data.filter(item => item.star) : data;
    data = filter !== '' ? data.filter(item => item.view.includes(filter.toLowerCase())) : data;
    return data.sort((a, b) => a.name.localeCompare(b.name) || a.id.localeCompare(b.id));
  }

  addContact(data, contactGroups) {
    this.items.push(new Contact(data, contactGroups));
  }

  updateContact(item) {
    const contact = this.items.filter(i => i.id.includes(item.id))[0];
    if (contact) contact.update(item);
  }

  deleteContact(item) {
    this.items = this.items.filter(i => !i.id.includes(item.id));
  }

  isEmpty() {
    return this.items.length;
  }
};

const ContactGroups = class {
  static STARRED_TITLE = 'Starred in Android';

  constructor(data) {
    this.data = data;
    this.starredGroupID = this.getStarredGroupID();
  }

  getStarredGroupID() {
    const entries = this.data.feed.entry;
    const starred = entries.filter(item => item.title.$t === ContactGroups.STARRED_TITLE);
    return starred.length ? starred[0].id.$t : null;
  }
};

export {
  Contacts,
  ContactGroups,

  EMAIL_HOME,
  EMAIL_WORK,
  EMAIL_OTHER,
  EMAIL_CUSTOM,
  EMAIL_TYPES,

  PHONE_MOBILE,
  PHONE_WORK,
  PHONE_HOME,
  PHONE_MAIN,
  PHONE_WORKFAX,
  PHONE_HOMEFAX,
  PHONE_PAGER,
  PHONE_OTHER,
  PHONE_CUSTOM,
  PHONE_TYPES,

  CONTACT_TEMPLATE,
  DEFAULT_TYPE,
};



// WEBPACK FOOTER //
// ./src/store/models/contacts.js